export default {
    // A
    addToFolders: 'Add to folders',
    addToFoldersText: 'Add media to folders to categorize and group your media. Use folder master cards to easily request edits for specific groups of media.',

    // C
    channelFolders: 'Channel folders',

    // E
    empty: 'Empty',

    // F
    favorites: 'Favorites',

    // G
    goToFolders: 'Go to folders',

    // I
    itemCount: 'no items | 1 item | {count} items',

    // N
    noItemsFound: 'viewing 0 videos',
    noRecentActivity: 'No recent activity',

    // R
    recentlyActive: 'Recently active',
    requestEditFromFolder: 'Request edit from folder',
    requestEditFromFolders: 'Request edit from folders',

    // S
    smartCollections: 'Smart Collections',

    // U
    updatedRelative: 'updated {relative}',
}
